<script setup lang="ts">
    import { computed, onMounted, type Ref } from 'vue'
    import { useRoute } from 'vue-router'
    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import { useResourceConstraintPageQueryV1 } from '@Quest/PortfolioScenarios/queries-vue-composables'
    import type { ResourceConstraintPageReadModel } from '@Quest/PortfolioScenarios/readmodels'

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))
    const scenarioId = computed(() => String(route.params.scenarioId ?? ''))
    const resourceId = computed(() => String(route.params.resourceId ?? ''))

    const {
        runResourceConstraintPageQueryV1,
        modelResourceConstraintPageQueryV1
    } = useResourceConstraintPageQueryV1(
        workspaceId,
        tchProjectId,
        scenarioId,
        resourceId
    )

    const rm = modelResourceConstraintPageQueryV1 as Ref<ResourceConstraintPageReadModel | null>

    onMounted(() =>
    {
        document.title = "Portfolio Plan - Resource"
        runResourceConstraintPageQueryV1()
    })
</script>

<template>
    <div>

        <PortfolioNavigation :workspaceId="workspaceId" :projectId="tchProjectId" />

        <div v-if="rm" class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h6>
                        <a class="text-dark" v-sanitizedHref="`/#/portfolio-plan/selection/${workspaceId}/${tchProjectId}/${scenarioId}`">
                            <i class="fa fa-angle-double-left" aria-hidden="true"></i> Back to plan
                        </a>
                    </h6>
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">{{rm.ResourceName}}</h1>
                </div>
                <div class="col-lg-6 text-right align-self-end">

                </div>
            </div>

            <hr class="my-5" />

            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th rowspan="2">Project</th>
                        <th rowspan="2">Selection</th>
                        <th rowspan="2">Start date</th>
                        <th colspan="3">
                            {{rm.ResourceName}} [{{rm.ResourceUnit}}]
                        </th>
                    </tr>
                    <tr>
                        <th>Requested</th>
                        <th>Committed</th>
                        <th>Planned</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="p in rm.Projects" :key="p.Id">
                        <td>{{p.Name}}</td>
                        <td>{{p.Acceptance}}</td>
                        <td>{{p.StartDate}}</td>
                        <td>{{p.ResourceRequested}}</td>
                        <td>{{p.ResourceCommitted}}</td>
                        <td>{{p.ResourcePlanned}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

